import { zhCN_TraceabilityResult } from './result';

export const zhCN_Traceability = {
  ...zhCN_TraceabilityResult
};
